import App from './app';
import AppConfig from './appConfig';
import AppContent from './appContent';
import AppManifest from './appManifest';
import ContainerConfig from './containerConfig';

/**
 * Class stubs for documentation purposes
 * @main F2
 */
export default {
	App,
	AppConfig,
	AppContent,
	AppManifest,
	ContainerConfig
};
